export enum AuthorityProfile {
  CONFIGURATION_PROFILE_PERMISSIONS_VIEW = '9.1.1',
  PROFILE_READ = '6.2.1',
  PROFILE_CREATE = '6.2.2',
  PROFILE_UPDATE = '6.2.4',
  PROFILE_DELETE = '6.2.3',
}
